var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Subheader",
        {
          attrs: {
            title: "Discrete Sample Stations",
            search: "Discrete Sample Stations",
          },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { small: "", color: "success" },
              on: {
                click: function ($event) {
                  return _vm.clickAddStation()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("Button.add_station")) + "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-text", [
            _vm._v(
              "\n      To recover a deleted station, please contact EIS with the station's name.\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-data-table",
            {
              attrs: {
                headers: _vm.headers,
                items: _vm.discreteSampleStations,
                pagination: _vm.pagination,
                search: _vm.search,
                "item-key": "name",
              },
              on: {
                "update:pagination": function ($event) {
                  _vm.pagination = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function (props) {
                    return [
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.locationType)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-right" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", dark: "", color: "delete" },
                              on: {
                                click: function ($event) {
                                  _vm.deleteStation = props.item
                                  _vm.confirmDialog = true
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("delete_forever"),
                              ]),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("Button.Delete")) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "template",
                { slot: "no-data" },
                [
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.progress,
                        expression: "progress",
                      },
                    ],
                    attrs: { indeterminate: "", color: "secondary" },
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.progress,
                          expression: "!progress",
                        },
                      ],
                    },
                    [_vm._v("No data available")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "removePadding",
                  attrs: { dense: "", color: "secondary", dark: "" },
                },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationDiscreteSampleStations.addTitleMsg"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pa-3": "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Station Name" },
                            model: {
                              value: _vm.newStation,
                              callback: function ($$v) {
                                _vm.newStation = $$v
                              },
                              expression: "newStation",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: "Station Category",
                              items: _vm.stationCategories,
                              "item-text": "Name",
                              "item-value": "Name",
                              hint: "when category is empty, it will be set to 'Unknown'",
                              "persistent-hint": "",
                            },
                            model: {
                              value: _vm.category,
                              callback: function ($$v) {
                                _vm.category = $$v
                              },
                              expression: "category",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-",
                            attrs: {
                              color: "info",
                              label: "Auto-assign to a location",
                              "persistent-hint": "",
                              hint: "Station will be assigned to a new or existing location.",
                            },
                            model: {
                              value: _vm.autoAssign,
                              callback: function ($$v) {
                                _vm.autoAssign = $$v
                              },
                              expression: "autoAssign",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loading.submit,
                        color: "success",
                        small: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.clickSave()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Save")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clearForm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800" },
          model: {
            value: _vm.confirmDialog,
            callback: function ($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationDiscreteSampleStations.confirmTitleMsg",
                          { msg: _vm.deleteStation.name }
                        )
                      ) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AdministrationDiscreteSampleStations.confirmTextMsg"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.agreeDeleteStation()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("Button.REMOVE_STATION")) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.CANCEL")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }